import React, { useState } from "react";
import { CircularProgress, Grid2, Snackbar } from "@mui/material";
import styles from "./ConnectInstance.module.scss";
import CustomInput from "../CustomInput/CustomInput";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";

export function ConnectInstance(props) {
  const {
    header,
    onClick,
    buttonText,
    details = [],
    inputs = [],
    helpLink,
    buttonLoading,
  } = props;
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const copyToClipboard = async (text, idx) => {
    if (!text) return;
    try {
      setSnackbarOpen(true);
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.setAttribute("readonly", "");
        ta.style.position = "absolute";
        ta.style.left = "-9999px";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setCopiedIndex(idx);
      setTimeout(() => setCopiedIndex(null), 2000);
    } catch {}
  };

  return (
    <Grid2 className={styles.connectInstanceContainer}>
      <Grid2 className={styles.headerFlex}>
        <Grid2 className={styles.header}>{header}</Grid2>
        {helpLink && (
          <ContactSupportOutlinedIcon
            className={styles.helpIcon}
            onClick={() => window.open(helpLink, "_blank")}
          />
        )}
      </Grid2>

      <Grid2 className={styles.displayFlexText}>
        {details.map((item, index) => (
          <>
            <Grid2 key={index} className={styles.width50}>
              <Grid2 className={styles.title}>{item.title}</Grid2>
              <Grid2 className={styles.subTitle}>{item.subTitle}</Grid2>

              {item.showButton && (
                <Grid2 className={styles.button} onClick={onClick}>
                  {buttonLoading ? (
                    <Grid2 className={styles.buttonContent}>
                      <CircularProgress size={18} className={styles.loader} />
                    </Grid2>
                  ) : (
                    <>
                      <FileDownloadOutlinedIcon />
                      {buttonText}
                    </>
                  )}
                </Grid2>
              )}

              {item.text && (
                <Grid2 className={styles.displayFlexCopy}>
                  <Grid2 className={styles.text}>{item.text}</Grid2>
                  <FileCopyOutlinedIcon
                    className={styles.copyIcon}
                    onClick={(e) => {
                      e.stopPropagation();
                      copyToClipboard(item.text, index);
                    }}
                    title={copiedIndex === index ? "Copied" : "Copy"}
                    role="button"
                    aria-label={copiedIndex === index ? "Copied" : "Copy"}
                  />
                </Grid2>
              )}

              {item.noteText && (
                <Grid2 className={styles.noteText}>{item.noteText}</Grid2>
              )}

              {item.link && (
                <Grid2
                  className={styles.link}
                  onClick={() => window.open(item.linkUrl, "_blank")}
                >
                  {item.link}
                </Grid2>
              )}
            </Grid2>
            {index < details.length - 1 && (
              <Grid2 className={styles.detailsLine} />
            )}
          </>
        ))}
      </Grid2>

      <Grid2 className={styles.line} />

      {inputs.length > 0 && inputs[0].header && (
        <Grid2>
          <Grid2 className={styles.title}>{inputs[0].header}</Grid2>
          {inputs[0].subHeader && (
            <Grid2 className={styles.subTitle}>{inputs[0].subHeader}</Grid2>
          )}
        </Grid2>
      )}

      <Grid2 className={styles.displayFlex}>
        {inputs
          .filter((field) => field.title)
          .map((field, idx) => (
            <CustomInput
              key={idx}
              title={field.title}
              placeHolder={field.placeHolder}
              value={field.value}
              disabled={true}
              suffix={
                <FileCopyOutlinedIcon
                  className={styles.copyIcon}
                  onClick={(e) => {
                    e.stopPropagation();
                    copyToClipboard(field.placeHolder, `input-${idx}`);
                  }}
                  title={copiedIndex === `input-${idx}` ? "Copied!" : "Copy"}
                />
              }
            />
          ))}
      </Grid2>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        message="Copied to clipboard"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </Grid2>
  );
}
